import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

import { ref, reactive, onMounted, watch, watchEffect, toRaw, computed } from 'vue'
import { cloneDeep, isEqual } from 'lodash-es'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import GcCodeSelect from '@/components/GcCodeSelect'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import { selectForNumberValidate } from '@/utils/validate'
import { Form } from 'ant-design-vue'
import { businessStatusEnum, orderTypeEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { paramCodesDataFilter } from '@/utils'
import type { ParamCodeItem } from '@/typings/common'
import type { SelectProps } from 'ant-design-vue'
import type { FbuBusinessEditParams } from '@/typings/api/chanceManage'
import { getLastChance } from '@/api/gucangSales/chanceManage'

const __default__ = { name: 'BusinessForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: {},
    title: {},
    type: {},
    saleChanceRefId: { type: Boolean },
    originalStatus: {},
    arkCodeId: { type: Boolean },
    isFromPotentialCustomer: { type: Boolean }
  },
  emits: ['update:value', 'planSaleAmount'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const useForm = Form.useForm
const props = __props
onMounted(() => {
  getByParamCodes()
})
const businessStatusEnumFilter = ref<any[]>()
const isEdit = computed(() => props.type !== 'view')
const isAddOrCopy = computed(() => (props.type === 'add' || props.type === 'copy'))
const logisticsProductsEnum = ref<SelectProps['options']>([])
const paramCodeData = ref<{
  fbu_chance_type: ParamCodeItem[]
  fbu_head_domestic_warehouse: ParamCodeItem[]
  fbu_head_destination_country_warehouse: ParamCodeItem[]
  fbu_head_replenish_method: ParamCodeItem[]
  fbu_head_competitors: ParamCodeItem[]
  fbu_tail_warehouse_name: ParamCodeItem[]
  fbu_warehouse: ParamCodeItem[]
}>({
  fbu_chance_type: [], // 商机类型
  fbu_head_domestic_warehouse: [], // 国内仓库
  fbu_head_destination_country_warehouse: [], // 目的国仓库
  fbu_head_replenish_method: [], // 运输方式
  fbu_head_competitors: [], // 头程竞争对手
  fbu_tail_warehouse_name: [], // 尾程仓库名称
  fbu_warehouse: [] // 尾程竞争对手（目前合作海外仓）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: [
      'fbu_chance_type',
      'fbu_head_domestic_warehouse',
      'fbu_head_destination_country_warehouse',
      'fbu_head_replenish_method',
      'fbu_head_competitors',
      'fbu_tail_warehouse_name',
      'fbu_warehouse'
    ]
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    paramCodeData.value = res.data
  })
}
const dataForm = reactive<FbuBusinessEditParams>({
  customerName: undefined,
  saleChanceRefId: undefined,
  arkCodeId: undefined,
  planSaleAmount: undefined,
  status: undefined,
  remark: undefined,
  chanceType: undefined,
  orderType: undefined,
  planSignTime: undefined,
  headDomesticWarehouse: undefined,
  headDestinationCountryWarehouse: undefined,
  headTransportMode: undefined,
  headCompetitors: undefined,
  tailWarehouse: undefined,
  tailProductName: undefined,
  tailCompetitors: undefined
})
/// 上个商机的月均预计销售额
const lastPlanSaleAmount = ref<number>()

const emit = __emit
watch(
  () => props.value,
  (val) => {
    if (!val) return
    // 如果值相同则不更新
    const isSame = isEqual(toRaw(dataForm), toRaw(val))
    if (isSame) return
    const clone = cloneDeep(val)
    Object.assign(dataForm, clone)
    if (props.type === 'view') {
      setTimeout(() => clearValidate())
    }
  },
  { deep: true, immediate: true }
)
// const businessStatusEnumFilter = computed(() => {
//   return businessStatusEnum.map((item) => ({ ...item, disabled: (props.type === 'add' || props.type === 'copy') && item.value === 6 }))
// })
watch(() => props.originalStatus,
  (val) => {
    const currentStatus = props.originalStatus
    if (!currentStatus) {
      return
    }
    switch (props.type) {
      case 'view':
        businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === currentStatus)
        break
      case 'copy':
        businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 5)
        break
      case 'add':
      case 'edit':
        if (currentStatus < 4) {
          businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === currentStatus || item.value === currentStatus + 1 || item.value === currentStatus + 2 || item.value === 6)
        } else if (currentStatus === 4) {
          businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === currentStatus || item.value === 6)
        } else if (currentStatus === 6) {
          /// 未能合作商机，支持可以修改商机状态为【初步接洽】、【确认需求】、【制定方案】
          businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value < 5 || item.value === 6)
        } else {
          businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === currentStatus)
        }
        break
    }
  })
watch(
  dataForm,
  (val) => {
    emit('update:value', val)
  },
  { deep: true }
)
watch(
  lastPlanSaleAmount,
  (val) => {
    emit('planSaleAmount', val)
  },
  { deep: true }
)

const isHeadOd = ref<boolean>()
const istailOd = ref<boolean>()
const isRequiredCustomer = ref<boolean>()
const isEmptyCustomer = ref<boolean>()
watchEffect(() => {
  // 监听订单类型，切换不同表单项
  if (dataForm.orderType === 1) {
    isHeadOd.value = true
    istailOd.value = false
  } else if (dataForm.orderType === 2) {
    istailOd.value = true
    isHeadOd.value = false
  } else {
    isHeadOd.value = undefined
    istailOd.value = undefined
  }

  // 监听尾程仓库名称变化，更新物流产品数据
  if (dataForm.tailWarehouse) {
    const find = paramCodeData.value.fbu_tail_warehouse_name.find((item) => item.id === dataForm.tailWarehouse)
    if (find?.children && find.children.length > 0) {
      logisticsProductsEnum.value = find.children.map((item) => ({
        label: item.name,
        value: item.id
      }))
    } else {
      logisticsProductsEnum.value = []
    }
  }
})

// 监听是否转潜在客户(客户代码非必填)
// 监听有客户代码数据时则必选
watch(
  [props.isFromPotentialCustomer, isEmptyCustomer],
  ([isFromPotential, isEmptyCustomer]) => {
    if (isFromPotential || isEmptyCustomer) {
      isRequiredCustomer.value = false
    } else {
      isRequiredCustomer.value = true
    }
    if (props.type === 'edit' || props.type === 'view') {
      setTimeout(() => clearValidate(['arkCodeId']), 0)
    }
  },
  { immediate: true }
)
const changeTypeChangeEvent = (value: any) => {
  console.log(value)
  if (!value) {
    return
  }
  /// 这里进判断新增和复制的时候来切换商机状态列表
  if (isAddOrCopy.value) {
    /// 新商机
    if (value === 398) {
      dataForm.status = 1
      businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 1)
    } else if (value === 399) {
      dataForm.status = 5
      businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 5)
    }
  }
}
const handleTailWarehouseChange = (value: any) => {
  dataForm.tailProductName = undefined
  setTimeout(() => clearValidate(['tailProductName']), 0)
}
const handleCustomerNameChange = () => {
  setTimeout(() => clearValidate(['arkCodeId']), 0)
}
const formRules = reactive({
  saleChanceRefId: [{ required: true, message: '请选择客户名称' }],
  arkCodeId: [{ required: isRequiredCustomer, message: '请选择子客户代码' }],
  planSaleAmount: [{ required: true, message: '请输入预计月销售额' }],
  status: [{ required: true, validator: selectForNumberValidate, message: '请选择商机状态' }],
  chanceType: [{ required: true, validator: selectForNumberValidate, message: '请选择商机类型' }],
  orderType: [{ required: true, validator: selectForNumberValidate, message: '请选择订单类型' }],
  planSignTime: [{ required: true, message: '请选择预计达成时间' }],
  headDomesticWarehouse: [{ required: isHeadOd, validator: selectForNumberValidate, message: '请选择中转仓' }],
  headDestinationCountryWarehouse: [
    { required: isHeadOd, validator: selectForNumberValidate, message: '请选择目的国仓库' }
  ],
  headTransportMode: [{ required: isHeadOd, validator: selectForNumberValidate, message: '请选择运输方式' }],
  headCompetitors: [{ required: isHeadOd, message: '请选择头程竞争对手' }],
  tailWarehouse: [{ required: istailOd, validator: selectForNumberValidate, message: '请选择尾程仓库名称' }],
  tailProductName: [{ required: istailOd, validator: selectForNumberValidate, message: '请选择尾程物流产品名称' }],
  tailCompetitors: [{ required: istailOd, message: '请选择尾程竞争对手' }]
})
const { resetFields, validate, validateInfos, clearValidate } = useForm(dataForm, formRules)
const handleOrderTypeChange = (value: any) => {
  if (value === 1) {
    dataForm.tailWarehouse = undefined
    dataForm.tailProductName = undefined
    dataForm.tailCompetitors = undefined
  } else if (value === 2) {
    dataForm.headDomesticWarehouse = undefined
    dataForm.headDestinationCountryWarehouse = undefined
    dataForm.headTransportMode = undefined
    dataForm.headCompetitors = undefined
  } else {
    dataForm.headDomesticWarehouse = undefined
    dataForm.headDestinationCountryWarehouse = undefined
    dataForm.headTransportMode = undefined
    dataForm.headCompetitors = undefined

    dataForm.tailWarehouse = undefined
    dataForm.tailProductName = undefined
    dataForm.tailCompetitors = undefined
  }
  clearValidate([
    'headDomesticWarehouse',
    'headDestinationCountryWarehouse',
    'headTransportMode',
    'headCompetitors',
    'tailWarehouse',
    'tailProductName',
    'tailCompetitors'
  ])
}
/// 定义一个监听其他表单数据填写后查询达成时间的值
const couldFetchReachTimeStateComputed = computed(() => {
  if (isAddOrCopy.value) {
    if (!dataForm.arkCodeId) {
      return undefined
    }
    if (dataForm.orderType === 1) {
      if (!dataForm.headDomesticWarehouse) {
        return undefined
      }
      if (!dataForm.headDestinationCountryWarehouse) {
        return undefined
      }
      if (!dataForm.headTransportMode) {
        return undefined
      }
      return {
        arkCodeId: dataForm.arkCodeId,
        orderType: 1,
        headDomesticWarehouse: dataForm.headDomesticWarehouse,
        headDestinationCountryWarehouse: dataForm.headDestinationCountryWarehouse,
        headTransportMode: dataForm.headTransportMode
      }
    } else if (dataForm.orderType === 2) {
      if (!dataForm.tailWarehouse) {
        return undefined
      }
      if (!dataForm.tailProductName) {
        return undefined
      }
      return {
        arkCodeId: dataForm.arkCodeId,
        orderType: 2,
        tailWarehouse: dataForm.tailWarehouse,
        tailProductName: dataForm.tailProductName
      }
    }
  }
  return undefined
})
watch(() => couldFetchReachTimeStateComputed.value,
  (val) => {
    if (!couldFetchReachTimeStateComputed.value) {
      dataForm.chanceType = undefined
      dataForm.status = undefined
      businessStatusEnumFilter.value = []
      lastPlanSaleAmount.value = undefined
      return
    }
    getLastChance(couldFetchReachTimeStateComputed.value).then((res) => {
      if (res.data) {
        const lastStatus = res.data?.status
        /// 当获取到的上一条商机为未能合作或者关闭时 则显示为新商机
        if (lastStatus === 6 || lastStatus === 8) {
          lastPlanSaleAmount.value = undefined
          dataForm.chanceType = 398
          dataForm.status = 1
          businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 1)
        } else {
          lastPlanSaleAmount.value = res.data?.planSaleAmount
          dataForm.chanceType = 399
          dataForm.status = 5
          businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 5)
        }
      } else { /// 新商机
        lastPlanSaleAmount.value = undefined
        dataForm.chanceType = 398
        dataForm.status = 1
        businessStatusEnumFilter.value = businessStatusEnum.filter((item) => item.value === 1)
      }
      dataForm.reachTime = res.data?.reachTime || undefined
    })
    // // eslint-disable-next-line @typescript-eslint/no-empty-function
    // .finally(() => {})
  }
)
__expose({ resetFields, validate, clearValidate })

return (_ctx: any,_cache: any) => {
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, { scrollToFirstError: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_card, {
        title: props.title,
        span: 6
      }, {
        default: _withCtx(() => [
          _createVNode(_component_dc_form_item, _mergeProps({ label: "客户名称" }, _unref(validateInfos).saleChanceRefId), {
            default: _withCtx(() => [
              _createVNode(ClueAndCustomerSelect, {
                appId: "cos_fbu",
                value: dataForm.saleChanceRefId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.saleChanceRefId) = $event)),
                label: dataForm.customerName,
                "onUpdate:label": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.customerName) = $event)),
                disabled: !isEdit.value || props.saleChanceRefId || !isAddOrCopy.value,
                view: props.type === 'view',
                placeholder: "请选择客户名称",
                onChange: handleCustomerNameChange
              }, null, 8, ["value", "label", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_dc_form_item, _mergeProps({ label: "子客户代码" }, _unref(validateInfos).arkCodeId), {
            default: _withCtx(() => [
              _createVNode(_unref(GcCodeSelect), {
                cosId: dataForm.saleChanceRefId,
                label: dataForm.arkCode,
                "onUpdate:label": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.arkCode) = $event)),
                value: dataForm.arkCodeId,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.arkCodeId) = $event)),
                isEmpty: isEmptyCustomer.value,
                "onUpdate:isEmpty": _cache[4] || (_cache[4] = ($event: any) => ((isEmptyCustomer).value = $event)),
                disabled: !isEdit.value || props.arkCodeId || ((_ctx.originalStatus>4&&_ctx.originalStatus!=6)&&!isAddOrCopy.value),
                view: props.type === 'view',
                allowClear: ""
              }, null, 8, ["cosId", "label", "value", "isEmpty", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_dc_form_item, _mergeProps({ label: "商机类型" }, _unref(validateInfos).chanceType), {
            default: _withCtx(() => [
              _createVNode(_component_ParamCodesSelect, {
                value: dataForm.chanceType,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.chanceType) = $event)),
                options: paramCodeData.value.fbu_chance_type,
                disabled: !isEdit.value || !isAddOrCopy.value,
                view: props.type === 'view',
                allowClear: "",
                onChange: changeTypeChangeEvent
              }, null, 8, ["value", "options", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_dc_form_item, _mergeProps({ label: "订单类型" }, _unref(validateInfos).orderType), {
            default: _withCtx(() => [
              _createVNode(_component_CosSelect, {
                value: dataForm.orderType,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.orderType) = $event)),
                options: _unref(orderTypeEnum),
                disabled: !isEdit.value || !isAddOrCopy.value,
                view: props.type === 'view',
                allowClear: "",
                onChange: handleOrderTypeChange
              }, null, 8, ["value", "options", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          (isHeadOd.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_dc_form_item, _mergeProps({ label: "中转仓" }, _unref(validateInfos).headDomesticWarehouse), {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.headDomesticWarehouse,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.headDomesticWarehouse) = $event)),
                      options: paramCodeData.value.fbu_head_domestic_warehouse,
                      disabled: !isEdit.value || !isAddOrCopy.value,
                      view: props.type === 'view',
                      allowClear: ""
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_dc_form_item, _mergeProps({ label: "目的国仓库" }, _unref(validateInfos).headDestinationCountryWarehouse), {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.headDestinationCountryWarehouse,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dataForm.headDestinationCountryWarehouse) = $event)),
                      options: paramCodeData.value.fbu_head_destination_country_warehouse,
                      disabled: !isEdit.value || !isAddOrCopy.value,
                      view: props.type === 'view',
                      allowClear: ""
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_dc_form_item, _mergeProps({ label: "运输方式" }, _unref(validateInfos).headTransportMode), {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.headTransportMode,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((dataForm.headTransportMode) = $event)),
                      options: paramCodeData.value.fbu_head_replenish_method,
                      disabled: !isEdit.value || !isAddOrCopy.value,
                      view: props.type === 'view',
                      allowClear: ""
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_dc_form_item, _mergeProps({ label: "头程竞争对手" }, _unref(validateInfos).headCompetitors), {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.headCompetitors,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((dataForm.headCompetitors) = $event)),
                      options: paramCodeData.value.fbu_head_competitors,
                      view: props.type === 'view',
                      allowClear: "",
                      mode: "multiple",
                      "max-tag-count": !isEdit.value ? 100 : 'responsive'
                    }, null, 8, ["value", "options", "view", "max-tag-count"])
                  ]),
                  _: 1
                }, 16)
              ], 64))
            : _createCommentVNode("", true),
          (istailOd.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_dc_form_item, _mergeProps({ label: "尾程仓库名称" }, _unref(validateInfos).tailWarehouse), {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.tailWarehouse,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((dataForm.tailWarehouse) = $event)),
                      options: paramCodeData.value.fbu_tail_warehouse_name,
                      disabled: !isEdit.value || !isAddOrCopy.value,
                      view: props.type === 'view',
                      allowClear: "",
                      onChange: handleTailWarehouseChange
                    }, null, 8, ["value", "options", "disabled", "view"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_dc_form_item, _mergeProps({ label: "物流产品" }, _unref(validateInfos).tailProductName), {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: dataForm.tailProductName,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((dataForm.tailProductName) = $event)),
                      disabled: !isEdit.value || !isAddOrCopy.value,
                      options: logisticsProductsEnum.value,
                      allowClear: "",
                      view: props.type === 'view'
                    }, null, 8, ["value", "disabled", "options", "view"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_dc_form_item, _mergeProps({ label: "尾程竞争对手" }, _unref(validateInfos).tailCompetitors), {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      value: dataForm.tailCompetitors,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((dataForm.tailCompetitors) = $event)),
                      options: paramCodeData.value.fbu_warehouse,
                      view: props.type === 'view',
                      allowClear: "",
                      mode: "multiple",
                      "max-tag-count": !isEdit.value ? 100 : 'responsive'
                    }, null, 8, ["value", "options", "view", "max-tag-count"])
                  ]),
                  _: 1
                }, 16)
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_dc_form_item, _mergeProps({ label: "预计月销售额(万)" }, _unref(validateInfos).planSaleAmount), {
            default: _withCtx(() => [
              _createVNode(_component_CosInputNumber, {
                style: {"width":"100%"},
                min: 0,
                maxlength: 15,
                value: dataForm.planSaleAmount,
                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((dataForm.planSaleAmount) = $event)),
                disabled: !isEdit.value || (_ctx.originalStatus>6&&!isAddOrCopy.value),
                placeholder: "对应仓库及渠道的预计月销售额",
                view: props.type === 'view',
                oninput: "value=value.replace(/[^\\d.]/g,'')"
              }, null, 8, ["value", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_dc_form_item, _mergeProps({ label: "商机状态" }, _unref(validateInfos).status), {
            label: _withCtx(() => [
              _createTextVNode(" 商机状态 "),
              _createVNode(_component_a_tooltip, {
                placement: "topLeft",
                overlayStyle: { maxWidth: '800px' }
              }, {
                title: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessStatusEnumFilter.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.value
                    }, [
                      _createElementVNode("p", null, _toDisplayString(item.label) + _toDisplayString(item.desc ? `：${item.desc}` : ''), 1)
                    ]))
                  }), 128))
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(ExclamationCircleOutlined), { style: {"margin-left":"2px","font-size":"14px"} })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_CosSelect, {
                value: dataForm.status,
                "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((dataForm.status) = $event)),
                options: businessStatusEnumFilter.value,
                disabled: !isEdit.value,
                view: props.type === 'view',
                allowClear: ""
              }, null, 8, ["value", "options", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          _createVNode(_component_dc_form_item, _mergeProps({ label: "预计达成时间" }, _unref(validateInfos).planSignTime), {
            default: _withCtx(() => [
              _createVNode(CosSingleDateTimePicker, {
                startTime: dataForm.planSignTime,
                "onUpdate:startTime": _cache[16] || (_cache[16] = ($event: any) => ((dataForm.planSignTime) = $event)),
                isRange: false,
                disabled: !isEdit.value || ((_ctx.originalStatus>4&&_ctx.originalStatus!=6)&&!isAddOrCopy.value),
                view: props.type === 'view'
              }, null, 8, ["startTime", "disabled", "view"])
            ]),
            _: 1
          }, 16),
          (props.type === 'view'||props.type === 'edit'||(isAddOrCopy.value && dataForm.reachTime))
            ? (_openBlock(), _createBlock(_component_dc_form_item, {
                key: 2,
                label: "达成时间"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosInput, {
                    value: dataForm.reachTime,
                    "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((dataForm.reachTime) = $event)),
                    valueModifiers: { trim: true },
                    maxlength: 200,
                    disabled: true,
                    placeholder: "--",
                    view: props.type === 'view'
                  }, null, 8, ["value", "view"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (props.type === 'view'||props.type === 'edit')
            ? (_openBlock(), _createBlock(_component_dc_form_item, {
                key: 3,
                label: "完结时间"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosInput, {
                    value: dataForm.overTime,
                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((dataForm.overTime) = $event)),
                    valueModifiers: { trim: true },
                    maxlength: 200,
                    disabled: true,
                    placeholder: "--",
                    view: props.type === 'view'
                  }, null, 8, ["value", "view"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_col, { span: 24 }),
          _createVNode(_component_dc_form_item, {
            label: "备注",
            span: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CosTextarea, {
                value: dataForm.remark,
                "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((dataForm.remark) = $event)),
                maxlength: 2000,
                disabled: !isEdit.value || (_ctx.originalStatus>6&&!isAddOrCopy.value),
                view: props.type === 'view'
              }, null, 8, ["value", "disabled", "view"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}
}

})